import * as Sentry from '@sentry/react'

import { clientEnv } from '@/env.client'
import { getSentryEnvironment } from '@/shared/lib/monitoring/sentry'

const sentryEnvironment = getSentryEnvironment()
const isProduction = sentryEnvironment === 'production'

Sentry.init({
  dsn: clientEnv.NEXT_PUBLIC_SENTRY_DSN,
  environment: sentryEnvironment,
  enabled:
    !!clientEnv.NEXT_PUBLIC_SENTRY_DSN && sentryEnvironment !== 'development',
  integrations: [
    Sentry.browserTracingIntegration(),
    // O replay grava o que aconteceu ANTES do erro. Para um crash que não
    // reproduz em ambiente local nem com o dump de produção, é a única fonte
    // que sobrevive ao ocorrido — o stack diz onde quebrou, o replay diz o que
    // a aluna fez até ali.
    //
    // Só em produção: é lá que estão as ocorrências reais, e o replay não é
    // barato nem em cota nem em bytes no bundle.
    //
    // `maskAllText` e `blockAllMedia` já são o padrão do SDK; ficam explícitos
    // porque a base de usuários é formada por menores de idade e essa decisão
    // não deve depender de um default continuar sendo o que é.
    ...(isProduction
      ? [Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true })]
      : [])
  ],
  // Fora de produção não há volume que justifique tracing — só consumo de cota.
  tracesSampleRate: isProduction ? 0.1 : 0,
  // Sessão comum nunca é gravada. Em produção, sessão que termina em erro é
  // gravada sempre: é exatamente o caso que se quer diagnosticar. Em staging,
  // nada é gravado.
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: isProduction ? 1.0 : 0,

  // Filtros deliberadamente curtos. Há um bug de causa desconhecida em aberto,
  // e um `ignoreErrors` generoso esconderia justamente o que se quer capturar.
  // Só entra aqui ruído que comprovadamente não é da aplicação.
  ignoreErrors: [
    // Alarme falso do próprio navegador: não quebra nada e não tem ação.
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications'
  ],
  // Erro lançado dentro de extensão do navegador não é código nosso e não é
  // acionável — e em base grande de aparelhos é o maior gerador de volume.
  denyUrls: [/^chrome-extension:\/\//i, /^moz-extension:\/\//i, /^safari-extension:\/\//i]
})
